import { CheckIcon } from "@heroicons/react/24/solid";

export function Stepper({ steps, currentStep }) {
  return (
    <nav aria-label="Progress" className="w-full">
      <ol className="flex justify-between items-start relative">
        {steps.map((step, idx) => {
          const isCompleted = currentStep > idx;
          const isCurrent = currentStep === idx;

          return (
            <li key={step.id} className="flex-1 relative flex flex-col items-center">
              {/* Connector Line */}
              {idx !== 0 && (
                <span
                  className={`absolute top-6 left-0 h-1 z-0 w-full ${
                    isCompleted ? "bg-blue" : "bg-gray-300"
                  }`}
                  style={{ transform: "translateX(-50%)" }}
                />
              )}

              {/* Step Circle */}
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center z-10 transition-all duration-300
                  ${isCompleted ? "bg-blue" : isCurrent ? "bg-white border-2 border-blue" : "bg-white border-2 border-gray-300"}`}
              >
                {isCompleted ? (
                  <CheckIcon className="w-6 h-6 text-white" />
                ) : (
                  <span className={`${isCurrent ? "text-blue" : "text-gray-400"} font-semibold`}>
                    {step.id}
                  </span>
                )}
              </div>

              {/* Label */}
              <p
                className={`mt-3 text-sm font-medium text-center transition-colors duration-300
                  ${isCompleted ? "text-gray-900" : isCurrent ? "text-blue" : "text-gray-400"}`}
              >
                {step.name}
              </p>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}